<template>
    <div class="login">
        <div id="loginContainer">
            <div class="screen" :style="{ backgroundImage: `url('${backgroundImage}')`, backgroundSize: 'cover' }">
            </div>
            <div class="form_wrapper" v-show="loginForm">
                <div class="logo">
                </div>
                <div class="title">
                    登录Nike学道直播
                </div>
                <div class="form">
                    <div class="input-item">
                        <el-input v-model="cellphone" placeholder="请输入手机号" class="input-wrapper" maxlength="11">
                        </el-input>
                        <span class="item-title">手机号</span>
                    </div>
                    <div class="input-item">
                        <el-input v-model="password" placeholder="请输入密码" class="input-wrapper" show-password
                            @keyup.enter.native="login">
                        </el-input>
                        <span class="item-title">密码</span>
                    </div>
                    <div class="forget-password" @click="loginForm = false">忘记密码？</div>
                    <el-button @click="login">登录</el-button>
                </div>
            </div>
            <div class="form_wrapper" v-show="!loginForm">
                <div class="logo">
                </div>
                <div class="title">
                    重置密码
                </div>
                <div class="form forget">
                    <div class="input-item">
                        <el-input v-model="cellphone" placeholder="请输入手机号" class="input-wrapper" maxlength="11">
                        </el-input>
                        <span class="item-title">手机号</span>
                        <div class="valid-send" @click="sendValid" :disabled="countDown > 0">
                            {{ countDown > 0 ? countDown + 'S' : '发送验证码' }}</div>
                    </div>
                    <div class="input-item">
                        <el-input v-model="valid" placeholder="请输入验证码" class="input-wrapper">
                        </el-input>
                        <span class="item-title">验证码</span>
                    </div>
                    <div class="input-item">
                        <el-input v-model="password" placeholder="请输入新密码" class="input-wrapper" show-password
                            @keyup.enter.native="login">
                        </el-input>
                        <span class="item-title">新密码</span>
                    </div>
                    <el-button @click="resetPassword">确认重置</el-button>
                    <div class="back-login" @click="loginForm = true"><i class="el-icon-back"></i>返回登陆</div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

export default {
    data: () => {
        return {
            cellphone: "",
            password: "",
            valid: "",
            backgroundImage: null,
            loginForm: true,
            countDown: 0,
            target: null,
            countDownTimer: null,
        }
    },
    mounted() {
        this.load()
    },
    methods: {
        async load() {
            let resp = await this.$action.live.getConfigs();
            this.backgroundImage = resp ? resp.h5CoverImage : null
        },
        async sendValid() {
            let that = this
            if (this.countDown > 0) return;

            if (!this.cellphone) {
                this.$message.error('请输入手机号码！')
                return;
            }

            let resp = await this.$action.pub.sendValidCode(this.cellphone);
            if (resp) {
                this.$message.success('发送成功！')
            } else {
                return;
            }

            this.countDown = 300
            that.target = Date.now() + 300 * 1000
            if (!this.countDownTimer) {
                this.countDownTimer = setInterval(function () {
                    that.countDown = parseInt((that.target - Date.now()) / 1000)
                    if (that.countDown < 0) {
                        clearInterval(that.countDownTimer)
                    }
                }, 999)
                console.log(that.countDownTimer)
            }
        },
        async resetPassword() {
            let resp = await this.$action.pub.updatePassword(this.cellphone, this.password, this.valid);
            if (resp) {
                this.$message.success('密码修改成功！')
                this.loginForm = true
            }
        },
        async login() {
            let resp = await this.$action.pub.login(this.cellphone, this.password);
            if (resp) {
                CookieManage.set('live-token', resp.token)
                CookieManage.set('live-account', resp.Account.account)
                CookieManage.set('live-cellphone', resp.Account.cellphone)
                CookieManage.set('live-name', resp.Account.name)
                CookieManage.set('live-headImg', resp.Account.imageUrl)

                let pendant = await this.$action.competition.getPendant(resp.Account.account)
                let headPendant = '';
                if (pendant && pendant[0].head) {
                    headPendant = pendant[0].head;
                }

                CookieManage.set('live-pendant-headImg', headPendant)
                let liveId = this.$route.query.liveId
                if (liveId) {
                    let hasAuthorization = await this.$action.live.checkAuthorization(liveId)
                    // console.log(hasAuthorization)
                    if (hasAuthorization && hasAuthorization.result) {
                        this.$router.push({ path: `/live/detail`, query: { liveId: liveId } });
                    }else{
                        this.$message.error("用户权限不足，无法观看对应ID的直播！")
                    }

                } else {
                    this.$router.push('/live/list')
                }
            } else {
                // this.$message.error("用户名或密码错误！")
            }

        }
    }
}
</script>

<style scoped>
.login {
    height: 100vh;
    width: 100vw;
    display: flex;
    background-color: white;
    justify-content: center;
    align-items: center;
    background-image: url('../../static/image/common/background-water.png');
    background-size: contain;
}

.login #loginContainer {
    margin: auto;
    height: 633px;
    width: 1605px;
    background-color: white;
    display: flex;
}

.login .screen {
    height: 633px;
    width: 1125px;
    box-shadow: 0px 0px 10px 1px rgba(0, 0, 0, 0.3);
    opacity: 1;
}

.login .form_wrapper {
    margin-left: 10px;
    width: 470px;
    height: 633px;
    box-shadow: 0px 0px 10px 1px rgba(0, 0, 0, 0.3);
    border-radius: 0px 0px 0px 0px;
    opacity: 1;
    padding: 30px;
}

.form_wrapper .logo {
    width: 100px;
    height: 36.09px;
    background-image: url('../../static/image/common/Nike-logo-2@2x.png');
    background-size: cover;
}

.form_wrapper .title {
    margin-top: 11px;
    width: 195px;
    height: 33px;
    color: #111111;
    font-family: 'nike-ch';
    font-size: 24px;
    font-weight: bolder;
}

.form_wrapper .form .input-item {
    position: relative;
    width: 410px;
    min-height: 70px;
    margin-top: 48px;
}

.form_wrapper .form .input-item .input-wrapper {
    margin-top: 10px;
    width: 410px !important;
    height: 60px !important;
}

.input-wrapper.el-input,
.input-wrapper .el-input__inner {
    width: 410px !important;
    height: 60px !important;
}

.form_wrapper .form .input-item .item-title {
    position: absolute;
    left: -9px;
    top: -9px;
    padding: 9px;
    font-size: 16px;
    font-weight: 500;
    color: #a7a7a7;
    max-width: fit-content;
    background-color: white;
}

.mobile .item-title {
    display: none;
}

.form_wrapper .form .input-item .valid-send {
    position: absolute;
    right: 9px;
    top: 18px;
    width: 108px;
    padding: 9px;
    font-size: 18px;
    font-weight: bolder;
    color: #111111;
    max-width: fit-content;
    background-color: white;
}

.form .forget-password {
    margin-top: 8px;
    margin-left: 330px;
    width: 80px;
    height: 22px;
    font-size: 16px;
    font-weight: 500;
    color: #a7a7a7;
}

.forget .back-login {
    margin-top: 20px;
    width: 94px;
    height: 24px;
    font-size: 17px;
    font-weight: bolder;
    color: #111111;
}

.forget .back-login i {
    font-size: 17px;
    font-weight: bolder;
    color: #020202;
}
</style>
<style>
.login .input-wrapper.el-input {
    font-size: 18px;
}

.login .input-wrapper .el-input__inner {
    width: 410px !important;
    height: 60px !important;
    border: 1px solid black;
    font-size: 18px;
}

.login input:-webkit-autofill,
.login input:-webkit-autofill:hover,
.login input:-webkit-autofill:focus,
.login input:-webkit-autofill:active {
    box-shadow: 0 0 0px 1000px transparent inset !important;
    -webkit-text-fill-color: #111111 !important;
    -webkit-background-clip: text;
    font-size: 18px !important;
}

.login .el-input .el-input__clear {
    font-size: 18px !important;
}

.login .form .el-button {
    margin-top: 40px !important;
    width: 410px !important;
    height: 60px !important;
    background-color: #111111;
    color: #fff;
    font-size: 20px;
    font-weight: 500;
}

.login .forget .el-button {
    margin-top: 50px !important;
    width: 410px !important;
    height: 60px !important;
    background-color: #111111;
    color: #fff;
    font-size: 20px;
}
</style>



// WEBPACK FOOTER //
// src/pages/login.vue